import { getScreenName } from '../../../Utils/helper';
import { fireEvent } from '../../../Utils/fireEvent';

export const showCollapsedView = (
  index,
  WidgetContainImage,
  openReturnPolicyWidget,
) => {
  // const value = getWebUserType() === "B";
  if ((!WidgetContainImage && index == 0) || openReturnPolicyWidget) {
    return true;
  } else if (index == 1 && WidgetContainImage) {
    return true;
  } else {
    return false;
  }
  // if (index == 1 && !value && WidgetContainImage)
  //     return true;
  // return false;
  //return true;
};
export const categoryNameExpanded = 'expanded_pdp_widget';
export const categoryNameCollapsed = 'collapsed_pdp_widget';

export const fireExpandCollpaseWidgetEvent = (
  categoryName,
  productData,
  index,
  name,
) => {
  fireEvent({
    category: categoryName,
    page_url: window.location.href,
    id: productData?.id,
    screen_name: getScreenName(),
    pdp_variant: 'aplus',
    selling_price: productData?.price,
    sku_nickname: productData?.nickname,
    sku_type: productData?.type,
    name: name,
    position: index,
  });
};
